/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsBCSQuestionsAnswerItem {
    getFixupPrototypeFunction() { return AppSecopsBCSQuestionsAnswerItem.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsBCSQuestionsAnswerItem>): AppSecopsBCSQuestionsAnswerItem {
        let obj = Object.assign(new AppSecopsBCSQuestionsAnswerItem(), model);
        AppSecopsBCSQuestionsAnswerItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsBCSQuestionsAnswerItem>): AppSecopsBCSQuestionsAnswerItem {
        if (!model) return null;
        return AppSecopsBCSQuestionsAnswerItem.newInstance(<AppSecopsBCSQuestionsAnswerItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsBCSQuestionsAnswerItem) {
        if (!obj) return;

        models.AppSecopsBCSQuestionsAnswerItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsBCSQuestionsAnswerItem): boolean {
        Object.setPrototypeOf(obj, AppSecopsBCSQuestionsAnswerItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.weight === undefined) {
            this.weight = 0;
        }
    }

    /**
     * Question ID
     */
    question_id: string;

    /**
     * Question weight (0-100)
     */
    weight: number;

}
